import { coresNomes } from '@src/constants/Color.js'

// Icone padrao de tarefa (manual/atrasada) no CRM — usado no mapTipoAtividade,
// CRM_TIPOS_ATIVIDADES e fallback do card-lead.
export const TASK_ACTIVITY_ICON = 'task-square'

export const mapStatusAdvisorTask = {
  Pendente: { label: 'Pendente', color: '#978B6B', index: 1 },
  Agendado: { label: 'Aprovado', color: '#E0AF00', index: 2 },
  'Em progresso': { label: 'Reprovado', color: '#19B4C6', index: 3 },
}

export const mapTableRelationshipTasks = {
  relacionamento_atrasadas: {
    label: 'Atividades de relacionamento atrasadas',
    shortLabel: 'Relacionamento atrasado',
    color: '#D2691E',
    index: 1,
  },
  tarefas_manuais_atrasadas: {
    label: 'Tarefas manuais atrasadas',
    shortLabel: 'Tarefa manual atrasada',
    color: '#CD8315',
    index: 2,
  },
  tarefas: {
    label: 'Tarefas manuais',
    shortLabel: 'Tarefa manual',
    color: '#C79D0B',
    index: 3,
  },
  tarefas_criticas: {
    label: 'Atividades prioritárias',
    shortLabel: 'Prioritária',
    color: '#EB5757',
    index: 4,
  },
  campanhas: {
    label: 'Campanhas',
    shortLabel: 'Campanha',
    color: '#BDA767',
    index: 5,
  },
  sugestao_alocacao: {
    label: 'Sugestão de alocação',
    shortLabel: 'Sugestão de alocação',
    color: '#AF9692',
    index: 6,
  },
  oportunidades: {
    label: 'Oportunidades',
    shortLabel: 'Oportunidade',
    color: '#8E8E8E',
    index: 7,
  },
  objetivos: {
    label: 'Objetivos',
    shortLabel: 'Objetivo',
    color: '#2F8F77',
    index: 8,
  },
}

export const mapTableRelationshipClients = {
  relacionamento_atrasadas: {
    label: 'Clientes com atividades de relacionamento atrasadas',
    shortLabel: 'Relacionamento atrasado',
    color: '#D2691E',
    index: 1,
  },
  tarefas_manuais_atrasadas: {
    label: 'Clientes com tarefas manuais atrasadas',
    shortLabel: 'Tarefa atrasada',
    color: '#CD8315',
    index: 2,
  },
  // Este slug NÃO representa o novo conceito de "cliente crítico" por pontuação
  // (score >= 750, ver core/relacionamentoScore.js) — ele mapeia o grupo do
  // backend produzido pela waterfall `_classify_client`, cujo significado é
  // "o cliente tem tarefa auto-sugerida". Manter o label "Crítico" aqui criaria
  // dois "críticos" com sentidos diferentes na mesma tela; por isso o label
  // renomeia para "atividade prioritária" e a chave (slug) permanece intocada.
  criticos: {
    label: 'Clientes com atividade prioritária',
    shortLabel: 'Atividade prioritária',
    color: '#EB5757',
    index: 3,
  },
  // Slug 'ativos' kept to match backend `grupo.identificador`; label is the
  // generic 'Clientes' since the 'inativos' bucket was removed (CU-86ah32kqr).
  ativos: { label: 'Clientes', color: '#56AF79', index: 4 },
}

export const mapResultadoColor = {
  concluido: 'success',
  pendente: '#978B6B',
  cancelado: 'danger',
}

export const mapTipoAtividade = {
  Atividade: {
    icon: 'menu-board',
    color: coresNomes.azulProfundo,
    iconSize: 14,
    name_pretty: 'Atividade',
  },
  atividade: {
    icon: 'menu-board',
    color: coresNomes.azulProfundo,
    iconSize: 14,
    name_pretty: 'Atividade',
  },
  Whatsapp: {
    icon: 'whatsapp',
    color: '#006D77',
    iconSize: 14,
    name_pretty: 'WhatsApp',
  },
  whatsapp: {
    icon: 'whatsapp',
    color: '#006D77',
    iconSize: 14,
    name_pretty: 'WhatsApp',
  },
  WhatsApp: {
    icon: 'whatsapp',
    color: '#006D77',
    iconSize: 14,
    name_pretty: 'WhatsApp',
  },
  Ligação: {
    icon: 'call',
    color: coresNomes.azulRoyal,
    iconSize: 14,
    name_pretty: 'Ligação',
  },
  ligacao: {
    icon: 'call',
    color: coresNomes.azulRoyal,
    iconSize: 14,
    name_pretty: 'Ligação',
  },
  Email: {
    icon: 'sms',
    color: coresNomes.roxo,
    iconSize: 12,
    name_pretty: 'E-mail',
  },
  'E-mail': {
    icon: 'sms',
    color: coresNomes.roxo,
    iconSize: 12,
    name_pretty: 'E-mail',
  },
  email: {
    icon: 'sms',
    color: coresNomes.roxo,
    iconSize: 14,
    name_pretty: 'E-mail',
  },
  'Email Enviado': {
    icon: 'direct-send',
    color: coresNomes.roxo,
    iconSize: 14,
    name_pretty: 'Email Enviado',
  },
  'Email Recebido': {
    icon: 'direct-inbox',
    color: coresNomes.roxo,
    iconSize: 14,
    name_pretty: 'Email Recebido',
  },
  'Email Aberto': {
    icon: 'eye',
    color: coresNomes.roxo,
    iconSize: 14,
    name_pretty: 'Email Aberto',
  },
  'Reunião presencial': {
    icon: 'profile-two-user',
    color: '#FF8D28',
    iconSize: 16,
    name_pretty: 'Reunião presencial',
  },
  Reunião: {
    icon: 'profile-two-user',
    color: '#FF8D28',
    iconSize: 16,
    name_pretty: 'Reunião',
  },
  reuniao: {
    icon: 'profile-two-user',
    color: '#FF8D28',
    iconSize: 16,
    name_pretty: 'Reunião',
  },
  'Vídeo chamada': {
    icon: 'video',
    color: 'success',
    iconSize: 16,
    name_pretty: 'Vídeo chamada',
  },
  comentario: {
    icon: 'comments',
    color: coresNomes.azulPetroleo,
    iconSize: 12,
    name_pretty: 'Comentário',
  },
  Comentário: {
    icon: 'comments',
    color: coresNomes.azulPetroleo,
    iconSize: 12,
    name_pretty: 'Comentário',
  },
  'Troca de etapa': {
    icon: 'arrow-swap-horizontal',
    color: coresNomes.dourado,
    iconSize: 16,
    name_pretty: 'Troca de etapa',
  },
  'Troca de régua': {
    icon: 'arrow-swap-horizontal',
    color: coresNomes.dourado,
    iconSize: 16,
    name_pretty: 'Troca de régua',
  },
  'Mudança status': {
    icon: 'arrow-swap-horizontal',
    color: coresNomes.laranjaDinamico,
    iconSize: 16,
    name_pretty: 'Mudança de status',
  },
  Agendamento: {
    icon: 'calendar',
    color: coresNomes.verdeInvestimento,
    iconSize: 16,
    name_pretty: 'Agendamento',
  },
  compliance: {
    icon: 'book-cover',
    color: coresNomes.azulRoyal,
    iconSize: 16,
    name_pretty: 'Compliance',
  },
  tarefa: {
    icon: TASK_ACTIVITY_ICON,
    color: coresNomes.dourado,
    iconSize: 16,
    name_pretty: 'Tarefa',
  },
  manual: {
    icon: TASK_ACTIVITY_ICON,
    color: coresNomes.dourado,
    iconSize: 16,
    name_pretty: 'Tarefa',
  },
  'Pessoa Criada': {
    icon: 'profile-tick',
    color: coresNomes.verdeInvestimento,
    iconSize: 18,
    name_pretty: 'Pessoa Criada',
  },
  'atividade-critica': {
    icon: 'warning-status',
    color: '#E53935',
    iconSize: 14,
    name_pretty: 'Atividade prioritária',
  },
  oportunidade: {
    icon: 'lamp-on',
    color: '#1E88E5',
    iconSize: 14,
    name_pretty: 'Oportunidade',
  },
  perda_lead: {
    icon: 'close-circle',
    color: 'danger',
    iconSize: 14,
    name_pretty: 'Lead perdido',
  },
  retorno_funil: {
    icon: 'repeat-circle',
    color: coresNomes.verdeInvestimento,
    iconSize: 14,
    name_pretty: 'Retorno ao funil',
  },
  Linkedin: {
    icon: 'mdi-linkedin',
    color: '#0A66C2',
    iconSize: 16,
    name_pretty: 'LinkedIn',
  },
  Documento: {
    icon: 'document',
    color: coresNomes.cinzaEscuro,
    iconSize: 14,
    name_pretty: 'Documento',
  },
}

export const CRM_TIPOS_ATIVIDADES = [
  {
    name: 'Comentário',
    icon: 'comments',
    color: coresNomes.azulPetroleo,
    iconSize: 12,
  },
  {
    name: 'Atividade',
    icon: 'menu-board',
    color: coresNomes.azulProfundo,
    iconSize: 14,
  },
  {
    name: 'WhatsApp',
    icon: 'whatsapp',
    color: '#006D77',
    iconSize: 14,
  },
  {
    name: 'Ligação',
    icon: 'call',
    color: coresNomes.azulRoyal,
    iconSize: 14,
  },
  {
    name: 'E-mail',
    icon: 'sms',
    color: coresNomes.roxo,
    iconSize: 14,
  },
  {
    name: 'Reunião',
    icon: 'profile-two-user',
    color: '#FF8D28',
    iconSize: 16,
  },
  {
    name: 'Reunião presencial',
    icon: 'profile-two-user',
    color: '#FF8D28',
    iconSize: 16,
  },
  {
    name: 'Vídeo chamada',
    icon: 'video',
    color: 'success',
    iconSize: 16,
  },
  {
    name: 'Troca de etapa',
    icon: 'arrow-swap-horizontal',
    color: coresNomes.dourado,
    iconSize: 16,
  },
  {
    name: 'Mudança de status',
    icon: 'arrow-swap-horizontal',
    color: coresNomes.laranjaDinamico,
    iconSize: 16,
  },
  {
    name: 'Agendamento',
    icon: 'calendar',
    color: coresNomes.verdeInvestimento,
    iconSize: 16,
  },
  {
    name: 'Compliance',
    icon: 'book-cover',
    color: coresNomes.azulRoyal,
    iconSize: 16,
  },
  {
    name: 'Tarefa',
    icon: TASK_ACTIVITY_ICON,
    color: coresNomes.dourado,
    iconSize: 16,
  },
]

// Fonte única de cor para o par lead/cliente em qualquer tela do CRM (cards
// de oportunidade, calendário, etc). Trocar a cor de um dos dois se reflete
// em cada lugar que consome esta constante — não redefinir localmente.
// Cliente em azul petróleo, Lead em cinza médio. Mesma cor no filete e no
// rótulo pros dois. (Já testamos Lead em ciano/azul — trocado pra evitar
// confusão com o azul do provedor externo "Google Agenda" no calendário, ver
// 'provedor-externo' abaixo.)
export const LEAD_CLIENT_TARGET_COLORS = {
  lead: {
    color: coresNomes.cinzaMedio,
    labelColor: coresNomes.cinzaMedio,
    label: 'Lead',
  },
  cliente: {
    color: coresNomes.azulPetroleo,
    labelColor: coresNomes.azulPetroleo,
    label: 'Cliente',
  },
}

export const CRM_ACTIVITY_COLORS = {
  lead: {
    prettyName: LEAD_CLIENT_TARGET_COLORS.lead.label,
    color: LEAD_CLIENT_TARGET_COLORS.lead.color,
  },
  cliente: {
    prettyName: LEAD_CLIENT_TARGET_COLORS.cliente.label,
    color: LEAD_CLIENT_TARGET_COLORS.cliente.color,
  },
  'provedor-externo': {
    prettyName: 'Google Agenda',
    color: '#039BE5',
  },
}

export const OPPORTUNITY_TEMPERATURE_COLORS = {
  quente: '#EB5757',
  morno: '#E0AF00',
  frio: '#5B9BD5',
}

// Cor do BaseStatus por tipo de chamada (API4Com). Consumido na coluna "Tipo"
// da tabela de ligações. Tokens compatíveis com BaseStatus em modo texto.
export const MAP_TIPO_CHAMADA_COLOR = {
  outbound: 'info', // Realizada
  inbound: 'success', // Recebida
}

// Cor do BaseStatus por causa de término (enum HangupCause). Consumido na
// coluna "Causa do desligamento". Verde = encerrou bem; vermelho = falha de
// contato; âmbar = sem atendimento; neutro = cancelada pela própria origem.
export const MAP_CAUSA_TERMINO_COLOR = {
  NORMAL_CLEARING: 'success',
  USER_BUSY: '#E0AF00',
  NO_ANSWER: '#E0AF00',
  NO_USER_RESPONSE: '#E0AF00',
  ORIGINATOR_CANCEL: '#8E8E8E',
  CALL_REJECTED: 'danger',
  UNALLOCATED_NUMBER: 'danger',
  NUMBER_CHANGED: '#E0AF00',
  ALLOTTED_TIMEOUT: '#E0AF00',
}
